import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ProductCardStaticPlaceholder from '../ProductCardStaticPlaceholder';

// This component allows us to render a group of static product card
// placeholders, without having to manually map over an array and add an
// exception for the ESLint react/no-array-index-key rule every time.
const ProductCardStaticPlaceholderGroup = t0 => {
  const $ = _c(2);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 12 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = <>{Array.from(Array(count)).map(_temp)}</>;
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
ProductCardStaticPlaceholderGroup.propTypes = {
  count: PropTypes.number
};
export default ProductCardStaticPlaceholderGroup;
function _temp(item, index) {
  return <ProductCardStaticPlaceholder key={index} />;
}